import { filterImage } from 'Utils/imageUtil.js';
import {
  TRANSFORM_IMAGE,
  REQUEST_UNLINK_IMAGE,
  RECEIVE_UNLINK_IMAGE_SUCCESS,
  RECEIVE_UNLINK_IMAGE_FAILURE,
} from './actionTypes';

import { submitUnlinkImages } from '../api/imageMatcherApi';

export const unlinkCaseImage =
  (documentId, pages = []) =>
  async (dispatch) => {
    dispatch(requestUnlinkImage());
    try {
      const response = await submitUnlinkImages(documentId, pages);
      dispatch(receiveUnlinkImageSuccess(response));
    } catch (error) {
      dispatch(receiveUnlinkImageFailure(error));
    }
  };

export function requestUnlinkImage() {
  return {
    type: REQUEST_UNLINK_IMAGE,
  };
}

export function receiveUnlinkImageSuccess(res) {
  return {
    type: RECEIVE_UNLINK_IMAGE_SUCCESS,
    receivedAt: Date.now(),
    status: res.status,
  };
}

export function receiveUnlinkImageFailure(error) {
  return {
    type: RECEIVE_UNLINK_IMAGE_FAILURE,
    error,
  };
}

export function transformImage(image, imageIndex, imageWidth, imageHeight, imageOperation) {
  const imageData = filterImage(image, imageWidth, imageHeight, imageOperation);

  return {
    type: TRANSFORM_IMAGE,
    pageContent: imageData,
    pageId: imageIndex,
  };
}
